<template>
  <div class="block">
      <div class="container">  
      <div class="row">
        <div class="input-field">
            <input id="name" type="text" v-model="name">
            <label for="name" class="active">Name</label>
        </div>
        <div class="input-field">
            <input id="email" type="email" class="validate" v-model="email" ref="email">
            <label for="email" class="active">Email</label>
        </div>
      </div>
   
     <div class="input-field">
        <input id="password" type="password" class="validate" v-model="password">
        <label for="email">Password</label>
    </div>

      <div class="row">
        <label><span>Select your activity</span></label>

        <div class="row">
          <div class="input-field col s6" v-for="activity in activities" :key="activity.name">
                  <label>
                      <input name="activity" type="radio" checked v-model="trainingPrograms" @change="changePrograms($event)" :value="activity.programs"/>
                      <span>{{activity.name}} - {{activity.programs.length}} days/week</span>
                  </label>
          </div>
        </div>
      </div>
      <div class="row">
          <div class="input-field">
              <input id="weight" type="number" step="0.1" min="0" class="validate" v-model.number="weight">
              <span>Weight in kg</span>
          </div>
      </div>
      <div class="row">
        <label><span>Gender</span></label>
        <div class="row">
          <div class="input-field col s6">
            <label>
              <input name="gender" type="radio" checked v-model="gender" value="male"/>
              <span>Male</span>
            </label>
          </div>
          <div class="input-field col s6">
            <label>
              <input name="gender" type="radio" v-model="gender" value="female"/>
              <span>Female</span>
            </label>
          </div>
        </div>
      </div>

      <div class="row"><button class="btn waves-effect waves-light right" v-on:click="register()" name="action">Sign Up
        </button></div>

</div>
  </div>
</template>

<script>
import M from 'materialize-css'
import api from '@/api'
import moment from 'moment'
import {displayError} from '@/helpers/error'
export default {
  name: 'register',
  data: function () {
    return {
      name: undefined,
      email: undefined,
      password: undefined,
      gender: 'male',
      weight: undefined,
      activities: [],
      trainingPrograms: undefined
    }
  },
  created () {
    this.activities = api.getActivityList(true)
  },
  methods: {
    changePrograms: function (e) {
      const programs = e.target._value
      this.trainingPrograms = programs
    },
    register: async function () {
      // check fields
      if (!(this.email && this.name)) {
        return M.toast({html: 'Name and Email are required'})
      }
      if (this.$refs.email.classList.contains('invalid')) {
        return M.toast({html: 'An email address is required'})
      }
      // create user
      var userData = {
        name: this.capitalize(this.name),
        email: this.email,
        gender: this.gender,
        trainingPrograms: this.trainingPrograms,
        sessionsPerWeek: this.trainingPrograms.length,
        weight: this.weight,
        registrationDate: moment(),
        isFirstLogin: true
      }
      await api.register(this.email, this.password, userData)
        .catch((e) => {
          displayError(e)
        })

      api.auth(this.email, this.password)
        .then((me) => {
          api.setCurrentUser(me)
          this.$reloadApp()
        })
        .catch((e) => {
          displayError(e)
        })
    },
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.block {
  padding-top: 10px;
  margin-top: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/auth/Register.vue